/**全局时间相关处理
 * 主要用于平衡本机时间和服务器时间，防止本机时间差距过大时，加密接口无法通过服务器校验
 */
/**本地时间与服务器时间的偏移量。毫秒 */
let loaclTimeOffset = 0

/**当前时间戳。本机时间综合偏移量所得出 */
export function currentTrueTime(): number {
  return Date.now() + loaclTimeOffset
}

/**本地时间是否已经进行校准 */
export function isTimeSet() {
  return loaclTimeOffset !== 0
}
